import { render, staticRenderFns } from "./CopyGraderuleSlidebar.vue?vue&type=template&id=24e2b5cf"
import script from "./CopyGraderuleSlidebar.vue?vue&type=script&lang=js"
export * from "./CopyGraderuleSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports